var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfLink',{staticClass:"sf-header-navigation-item__link",attrs:{"link":_vm.link}},[_c('span',{class:{
      'sf-header-navigation-item__link_bottom':
        _vm.currentCategory && _vm.uid == _vm.currentCategory.uid,
    }},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }